<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.pickup', 2) }}
        </h1>
      </v-flex>

      <v-flex xs4 offset-xs4 v-if="pickup">
        <v-card class="mt-4">
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout wrap>

                <v-flex xs12 sm12 md12 class="text-xs-center">
                  <p>{{ $t('date') }}</p>
                  <p>
                  <b>
                    {{ pickup.date_from | date('YYYY-MM-DD') }}
                  </b>
                  </p>
                </v-flex>

                <v-flex xs12 sm12 md12 class="text-xs-center">
                  <p>{{ $t('schedule') }}</p>
                  <p>
                  <b>
                    {{ pickup.date_from | date('HH:mm') }}
                    -
                    {{ pickup.date_to | date('HH:mm') }}
                  </b>
                  </p>
                </v-flex>

                <v-flex xs12 sm12 md12 class="text-xs-center">
                  <p>{{ $t('referenceNumber') }}</p>
                  <p>
                  <b>
                    {{ pickup.reference_number }}
                  </b>
                  </p>
                </v-flex>

                <v-flex xs12 sm12 md12 class="text-xs-center">
                  <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('back') }}</v-btn>
                  <v-btn color="warning" flat @click="retry" :loading="loading" :disabled="loading" v-if="pickup.status !== 'generated'">{{ $t('retry') }}</v-btn>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs4 offset-xs4>
        <h2 v-if="pickup">
          {{ $tc('reschedulePickup') }}
        </h2>
        <v-form @submit.prevent="submit">
          <v-card class="mt-4">
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-dialog ref="dateDialog" v-model="dateModal" :return-value.sync="date" persistent lazy full-width width="290px">

                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="date" label="Picker in dialog" prepend-icon="event" readonly v-on="on"></v-text-field>
                      </template>

                      <v-date-picker v-model="date" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="dateModal = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.dateDialog.save(date)">OK</v-btn>
                      </v-date-picker>

                    </v-dialog>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-select :items="timeRanges" label="Standard" item-text="title" item-value="id" v-model="selectedTime"></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

import Pickup from '@/client/pickup'

export default {
  name: 'ShipmentPickupView',

  props: {},

  data () {
    return {
      pickup: null,
      loading: false,
      dateModal: false,
      date: new Date().toISOString().substr(0, 10),
      selectedTime: '09:00,12:00',
      timeRanges: [
        { id: '09:00,12:00', title: '09:00 - 12:00' },
        { id: '12:00,15:00', title: '12:00 - 15:00' },
        { id: '15:00,18:00', title: '15:00 - 18:00' }
      ]
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetch () {
      const pickups = await Pickup.all({
        where: {
          shipment_id: this.$route.params.id
        }
      })

      if (pickups.length) {
        this.pickup = pickups[0]
      } else {
        this.pickup = null
      }
    },

    async submit () {
      const times = this.selectedTime.split(',')
      const dateFrom = moment(`${this.date}-${times[0]}`, 'YYYY-MM-DD-H:mm')
      const dateTo = moment(`${this.date}-${times[1]}`, 'YYYY-MM-DD-H:mm')
      const pickup = new Pickup({
        shipment_id: this.$route.params.id,
        date_from: dateFrom.format(),
        date_to: dateTo.format()
      })

      this.loading = true
      try {
        await pickup.save()
      } catch (err) {
        this.handleErr(err)
      }
      await this.fetch()
      this.loading = false
    },

    async retry () {
      this.loading = true
      this.pickup.id = null
      try {
        await this.pickup.save()
      } catch (err) {
        this.handleErr(err)
      }
      await this.fetch()
      this.loading = false
    }
  },

  watch: {
  },

  async mounted () {
    this.fetch()
  }
}
</script>
